module.exports = __webpack_public_path__ + "img/11.be05cb09.jpg";